<template>
  <el-row>
    <el-col>
      <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Proveedores"
            icon="mdi mdi-account-box success-text"
            :total="proveedoresCount"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Clientes"
            icon="mdi mdi-account-box-outline success-text"
            :total="clientesCount"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Tarjetahabientes"
            icon="mdi mdi-credit-card-multiple success-text"
            :total="tarjetahabienteCount"
            :loading.sync="loading"
          />
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Terminales"
            icon="mdi  mdi-printer-3d success-text"
            :total="terminalesCount"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>

      <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            :text="'Transacciones ' + LastYear"
            icon="mdi  mdi-cash-usd  success-text"
            :total="transaccionesLast"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            :text="'Transacciones ' + year"
            icon="mdi mdi-cash-usd success-text"
            :total="transacciones"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            :text="'Transacciones ' + getMes"
            text2="En Contrato"
            icon="mdi mdi-cash-usd success-text"
            :total="transaccionesMonth"
            :total2="0"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>
      <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            :text="'Monto en Transacciones ' + LastYear"
            icon="mdi  mdi-cash-multiple  success-text"
            :total="transaccionesMontoLast"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            :text="'Monto en Transacciones ' + year"
            icon="mdi mdi-cash-multiple success-text"
            :total="transaccionesMonto"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            :text="'Monto en Transacciones ' + getMes"
            icon="mdi mdi-cash-multiple success-text"
            :total="transaccionesMontoMonth"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>
      <!-- <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total de Estrellas"
            icon="mdi mdi-star warning-text"
            :total="myStarsAllCount"
            :loading.sync="loading"
          />
        </el-col>
      </el-row> -->
    </el-col>
  </el-row>
</template>

<script>
import CardTotal from "@/components/CardTotalOriginal.vue";

export default {
  name: "cardcountTerminal",
  data: function () {
    return {
      loading: false,
      loading1: false,
      loading2: false,
      drawerNaxyNotContract: false,
      proveedoresCount: 0,
      clientesCount: 0,
      terminalesCount: 0,
      tarjetahabienteCount: 0,
      transacciones: 0,
      transaccionesLast: 0,
      transaccionesMonth: 0,
      transaccionesMonto: 0,
      transaccionesMontoLast: 0,
      transaccionesMontoMonth: 0,
      year: new Date().getFullYear(),
      LastYear: new Date().getFullYear() - 1,
      month: new Date().getMonth() + 1
    };
  },
  components: {
    CardTotal
  },
  computed: {
    getMes: function () {
      var retorno;
      switch (this.month) {
        case 1:
          retorno = "Enero";
          break;
        case 2:
          retorno = "Febrero";
          break;
        case 3:
          retorno = "Marzo";
          break;
        case 4:
          retorno = "Abril";
          break;
        case 5:
          retorno = "Mayo";
          break;
        case 6:
          retorno = "Junio";
          break;
        case 7:
          retorno = "Julio";
          break;
        case 8:
          retorno = "Agosto";
          break;
        case 9:
          retorno = "Septiembre";
          break;
        case 10:
          retorno = "Octubre";
          break;
        case 11:
          retorno = "Noviembre";
          break;
        case 12:
          retorno = "Diciembre";
          break;
      }
      return retorno;
    }
  },
  created() {
    this.countProveedores();
    this.countClientes();
    this.countTarjetahabiente();
    this.countTerminales();
    this.countTransactions();
    this.countTransactionsMonth();
    this.countTransactionsLast();
    this.MontoTransactionsMonth();
    this.MontoTransactionsYear();
    this.MontoTransactionsLastYear();
  },
  methods: {
    countProveedores() {
      this.$http
        .get(`/api/tennos/GetProveedoresQty`)
        .then((resp) => {
          this.proveedoresCount = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    countClientes() {
      this.$http
        .get(`/api/tennos/GetClientesQty`)
        .then((resp) => {
          this.clientesCount = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    countTarjetahabiente() {
      this.$http
        .get(`/api/tennos/GetTarjetaHabienteQty`)
        .then((resp) => {
          this.tarjetahabienteCount = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    countTerminales() {
      this.$http
        .get(`/api/tennos/GetTerminalesQty`)
        .then((resp) => {
          this.terminalesCount = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    countTransactions() {
      this.$http
        .get(`/api/tennos/GetTransactionsYearQty`)
        .then((resp) => {
          this.transacciones = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    countTransactionsLast() {
      this.$http
        .get(`/api/tennos/GetTransactionsLastYearQty`)
        .then((resp) => {
          this.transaccionesLast = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    countTransactionsMonth() {
      this.$http
        .get(`/api/tennos/GetTtransactionsMotnhQty`)
        .then((resp) => {
          this.transaccionesMonth = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MontoTransactionsMonth() {
      this.$http
        .get(`/api/tennos/GetTtransactionsMotnhMonto`)
        .then((resp) => {
          this.transaccionesMontoMonth = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MontoTransactionsYear() {
      this.$http
        .get(`/api/tennos/GetTtransactionsYearMonto`)
        .then((resp) => {
          this.transaccionesMonto = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    MontoTransactionsLastYear() {
      this.$http
        .get(`/api/tennos/GetTtransactionsLastYearMonto`)
        .then((resp) => {
          this.transaccionesMontoLast = resp.data;
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    }
  }
};
</script>
<style>
.main-section {
  width: 100%;
  text-align: center;
  padding: 0px 0px;
  margin-bottom: 1%;
}
.dashbord {
  padding-left: 8px;

  display: inline-block;
  background-color: white;
  color: #fff;
  margin-top: 10px;
  width: 250px;
}
.icon-section i {
  font-size: 30px;
  padding: 10px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-top: -25px;
  margin-bottom: 10px;
  background-color: #34495e;
}
.icon-section p {
  margin: 0px;
  font-size: 20px;
  padding-bottom: 10px;
}
.detail-section {
  background-color: #2f4254;
  padding: 5px 0px;
}
.dashbord .detail-section:hover {
  background-color: #5a5a5a;
  cursor: pointer;
}
.detail-section a {
  color: #fff;
  text-decoration: none;
}
.dashbord-white .icon-section,
.dashbord-white .icon-section i {
  background-color: #34495e;
}
.dashbord-white .detail-section {
  background-color: #34495e;
}
.dashbord-green .icon-section,
.dashbord-green .icon-section i {
  background-color: #16a085;
}
.dashbord-green .detail-section {
  background-color: #149077;
}
.dashbord-orange .icon-section,
.dashbord-orange .icon-section i {
  background-color: #f39c12;
}
.dashbord-orange .detail-section {
  background-color: #da8c10;
}
.dashbord-blue .icon-section,
.dashbord-blue .icon-section i {
  background-color: #2980b9;
}
.dashbord-blue .detail-section {
  background-color: #2573a6;
}
.dashbord-red .icon-section,
.dashbord-red .icon-section i {
  background-color: #e74c3c;
}
.dashbord-red .detail-section {
  background-color: #cf4436;
}
.dashbord-skyblue .icon-section,
.dashbord-skyblue .icon-section i {
  background-color: #b679cf;
}
.dashbord-skyblue .detail-section {
  background-color: #b061d0;
}
</style>
